import { useQuery } from '@tanstack/react-query';
import {
  getPartnerDashboardAPI,
  getPartnerMenuAPI,
  getPartnerOrdersLiveAPI,
  getPartnerProductsAPI,
  getPartnerProductsLiveAPI,
  getPartnerSettlementDetailsAPI,
  getPartnerSettlementSummaryAPI,
  getPartnerSettlementsLiveAPI,
} from '../api/partner-dashboard.api';

// 파트너 대시보드 조회
export const usePartnerDashboard = () => {
  return useQuery({
    queryKey: ['partner-dashboard'],
    queryFn: getPartnerDashboardAPI,
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5분
  });
};

// 파트너 메뉴 조회
export const usePartnerMenu = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['partner-menu'],
    queryFn: getPartnerMenuAPI,
    enabled,
    retry: 1,
    staleTime: 10 * 60 * 1000, // 10분
  });
};

// 파트너 상품 조회 (MongoDB 캐시)
export const usePartnerProducts = (params?: {
  page?: number;
  limit?: number;
  search?: string;
}) => {
  return useQuery({
    queryKey: ['partner-products', params],
    queryFn: () => getPartnerProductsAPI(params),
    retry: 1,
    staleTime: 2 * 60 * 1000, // 2분
  });
};

// 파트너 상품 조회 (실시간)
export const usePartnerProductsLive = (params?: {
  page?: number;
  limit?: number;
}) => {
  return useQuery({
    queryKey: ['partner-products-live', params],
    queryFn: () => getPartnerProductsLiveAPI(params),
    retry: 1,
    staleTime: 30 * 1000, // 30초
  });
};

// 파트너 정산 조회 (실시간)
export const usePartnerSettlementsLive = (params?: {
  page?: number;
  limit?: number;
}) => {
  return useQuery({
    queryKey: ['partner-settlements-live', params],
    queryFn: () => getPartnerSettlementsLiveAPI(params),
    retry: 1,
    staleTime: 30 * 1000, // 30초
  });
};

// 파트너 주문 조회 (실시간)
export const usePartnerOrdersLive = (params?: {
  page?: number;
  limit?: number;
}) => {
  return useQuery({
    queryKey: ['partner-orders-live', params],
    queryFn: () => getPartnerOrdersLiveAPI(params),
    retry: 1,
    staleTime: 30 * 1000, // 30초
  });
};

// 파트너 정산 요약 조회
export const usePartnerSettlementSummary = (params?: {
  year?: number;
  month?: number;
}) => {
  return useQuery({
    queryKey: ['partner-settlement-summary', params],
    queryFn: () => getPartnerSettlementSummaryAPI(params),
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5분
  });
};

// 파트너 정산 상세 조회
export const usePartnerSettlementDetails = (params?: {
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
}) => {
  return useQuery({
    queryKey: ['partner-settlement-details', params],
    queryFn: () => getPartnerSettlementDetailsAPI(params),
    retry: 1,
    staleTime: 2 * 60 * 1000, // 2분
  });
};
